














































































































































































































































































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { AccountCertificateType, AccountCertificate } from '@/modules/AccountCertificate/interfaces/account-certificate'
import { getAccountCertificates } from '../gql/account.gql'
import { showErrors } from '@/utils/snack'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay } from '@/utils/dateTime'
import AccountCertificateDialog from '@/modules/AccountCertificate/scripts/account-certificate-dialog'

@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class AccountDetailCertificate extends mixins(AccountCertificateDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  accountId: number | null = null

  loading = false

  idCards: AccountCertificate[] = []
  ssn: AccountCertificate[] = []
  drivingLicenses: AccountCertificate[] = []
  ddc: AccountCertificate[] = []
  mvr: AccountCertificate[] = []
  other: AccountCertificate[] = []

  idCardTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'idNumber',
      title: 'Id Number',
      slots: { default: 'idNumber' },
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  ssnTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'ssn',
      title: 'SSN',
      slots: { default: 'ssn' },
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  drivingLicenseTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'licenseNumber',
      title: 'License Number',
      slots: { default: 'licenseNumber' },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  ddcTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  mvrTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'licenseNumber',
      title: 'License Number',
      slots: { default: 'licenseNumber' },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  otherTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      resizable: true
    },
    { field: 'idNumber',
      title: 'ID Number',
      slots: { default: 'idNumber' },
      width: 200,
      resizable: true
    },
    { field: 'ssn',
      title: 'SSN',
      slots: { default: 'ssn' },
      width: 200,
      resizable: true
    },
    { field: 'licenseNumber',
      title: 'License Number',
      slots: { default: 'licenseNumber' },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  dollarFilter = dollarFilter
  dateToDisplay = dateToDisplay

  mounted () {
    this.getAccountCertificates()
  }

  // 获取claim list
  async getAccountCertificates () {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: getAccountCertificates,
        variables: {
          accountId: +this.account.id,
          filter: {}
        }
      })
      const certificates = result.data.getAccountCertificates.accountCertificates
      this.idCards = []
      this.drivingLicenses = []
      this.ssn = []
      this.ddc = []
      this.mvr = []
      this.other = []
      for (const certificate of certificates) {
        switch (certificate.type) {
          case AccountCertificateType.ID_CARD:
            this.idCards.push(certificate)
            break
          case AccountCertificateType.DRIVING_LICENSE:
            this.drivingLicenses.push(certificate)
            break
          case AccountCertificateType.DDC:
            this.ddc.push(certificate)
            break
          case AccountCertificateType.SSN:
            this.ssn.push(certificate)
            break
          case AccountCertificateType.MVR:
            this.mvr.push(certificate)
            break
          case AccountCertificateType.OTHER:
            this.other.push(certificate)
            break
          default:
            break
        }
      }
      this.loading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  getLegalName (first: string, middle: string, last: string) {
    return ((first || '') + ' ' + (middle || '') + ' ' + (last || '')).trim() || '-'
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  newCertificate (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.accountId = Number(this.account.id)
    this.showAccountCertificateEditDialog(e)
  }

  async deleteAccountCertificateConfirm () {
    if (!this.targetAccountCertificate) {
      return
    }
    await this.deleteAccountCertificatePost()
    this.getAccountCertificates()
  }

  @Emit('refresh')
  onFormSuccess () {
    // do nothing
  }
}
